import { render, staticRenderFns } from "./TokenClubAddOnSelect.vue?vue&type=template&id=6d23264c&scoped=true"
import script from "./TokenClubAddOnSelect.vue?vue&type=script&lang=ts"
export * from "./TokenClubAddOnSelect.vue?vue&type=script&lang=ts"
import style0 from "./TokenClubAddOnSelect.vue?vue&type=style&index=0&id=6d23264c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23264c",
  null
  
)

export default component.exports